export const IS_MOBILE = !!navigator.userAgent.match(
  /android|iphone|webos|ipad|ipod|blackberry|windows phone/gi
);
